import { useCallback, useEffect, useState } from 'react'
import { useAppSelector } from '../redux/hook'
import { StructureStatusEnum } from '../models/enum/structure-status.enum';
import { convertRoleToStructureStatus } from '../utils/form-helper';

function useCheckLoginIsAdditionalRole() {
  
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);

  const [result, setResult] = useState<boolean | undefined>(undefined);
  const [isMainApplicantCreateApplication, SetIsMainApplicantCreateApplication] = useState<boolean | undefined>(undefined);


  const checkLoginRole = useCallback(()=>{
    const owners = applicationStartFormData.selected_hdb_property?.owners;
    const occupiers = applicationStartFormData.selected_hdb_property?.occupiers;
    
    const isOwnerOccupier = owners?.some(e=>e.uinfin === loginUser.uinfin) || occupiers?.some(e=>e.uinfin === loginUser.uinfin)

    if(isOwnerOccupier){
      setResult(false); //because is in owner or occupier.
    }
    else{
      const additional_roles = applicationStartFormData.selected_hdb_property?.additional_roles;
      const isAdditionalRole = additional_roles?.some(e=>{
        const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
        return roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator
      });

      setResult(isAdditionalRole);
    }
  },[applicationStartFormData.selected_hdb_property?.additional_roles, applicationStartFormData.selected_hdb_property?.occupiers, applicationStartFormData.selected_hdb_property?.owners, loginUser.uinfin])


  const checkIsMainApplicantCreatedApplication = useCallback(()=>{
    const owners = applicationStartFormData.selected_hdb_property?.owners;
    const occupiers = applicationStartFormData.selected_hdb_property?.occupiers;
    
    const isOwnerOccupier = owners?.some(e=>e.uinfin === applicationStartFormData.selected_hdb_property?.main_applicant_uinfin) || occupiers?.some(e=>e.uinfin === applicationStartFormData.selected_hdb_property?.main_applicant_uinfin)

    if(isOwnerOccupier){
      SetIsMainApplicantCreateApplication(false); //because is in owner or occupier.
    }
    else{
      const additional_roles = applicationStartFormData.selected_hdb_property?.additional_roles;
      const isAdditionalRole = additional_roles?.some(e=>{
        const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
        return (roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator) && e.uinfin === applicationStartFormData.selected_hdb_property?.main_applicant_uinfin;
      });

      SetIsMainApplicantCreateApplication(isAdditionalRole);
    }
  },[applicationStartFormData.selected_hdb_property?.additional_roles, applicationStartFormData.selected_hdb_property?.main_applicant_uinfin, applicationStartFormData.selected_hdb_property?.occupiers, applicationStartFormData.selected_hdb_property?.owners])

  useEffect(()=>{
    checkLoginRole();
    checkIsMainApplicantCreatedApplication();
  },[checkIsMainApplicantCreatedApplication, checkLoginRole])


  return { result, isMainApplicantCreateApplication }

  
}

export default useCheckLoginIsAdditionalRole